(function () {
  document.querySelectorAll('.drv-lres').forEach(function (root) {
    const topics = root.querySelectorAll('[data-drv-lres-topic]');
    const groups = root.querySelectorAll('[data-drv-lres-group]');
    const rail = root.querySelector('[data-drv-lres-rail]');
    const thumb = root.querySelector('[data-drv-lres-thumb]');
    const mobileMq = window.matchMedia('(max-width: 989.98px)');

    function activeGrid() {
      const g = root.querySelector('.drv-lres__group.is-active [data-drv-lres-grid]');
      return g || null;
    }

    function capGrid(grid) {
      const cards = grid.querySelectorAll('.drv-lres__card');
      if (!mobileMq.matches && cards.length > 6) {
        const d = cards[6].getBoundingClientRect().top - cards[0].getBoundingClientRect().top;
        if (d > 0) grid.style.maxHeight = (d - 20) + 'px';
      } else {
        grid.style.maxHeight = '';
      }
    }

    function updateRail() {
      if (!rail || mobileMq.matches) return;
      const grid = activeGrid();
      if (!grid) { rail.classList.remove('is-visible'); return; }
      capGrid(grid);
      if (grid.scrollHeight <= grid.clientHeight + 1) { rail.classList.remove('is-visible'); return; }
      rail.classList.add('is-visible');
      const max = grid.scrollHeight - grid.clientHeight;
      const range = rail.clientHeight - 4 - thumb.offsetHeight;
      thumb.style.transform = 'translateY(' + (max ? (grid.scrollTop / max) * range : 0) + 'px)';
    }

    function setActive(i) {
      topics.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      groups.forEach(function (g, k) { g.classList.toggle('is-active', k === i); });
      updateRail();
    }

    topics.forEach(function (t, i) {
      t.addEventListener('click', function () { setActive(i); });
    });

    groups.forEach(function (g, i) {
      const head = g.querySelector('[data-drv-lres-ghead]');
      if (head) head.addEventListener('click', function () {
        if (!mobileMq.matches) return;
        if (g.classList.contains('is-active')) {
          g.classList.remove('is-active');
          topics.forEach(function (t) { t.classList.remove('is-active'); });
        } else {
          setActive(i);
        }
      });
    });

    root.querySelectorAll('[data-drv-lres-grid]').forEach(function (grid) {
      const slider = grid.parentElement.querySelector('[data-drv-lres-slider]');
      const cards = grid.querySelectorAll('.drv-lres__card');
      if (slider && cards.length > 1) {
        slider.hidden = false;
        cards.forEach(function (_, k) {
          const s = document.createElement('span');
          s.className = 'drv-lres__seg' + (k === 0 ? ' is-active' : '');
          slider.appendChild(s);
        });
        grid.addEventListener('scroll', function () {
          if (!mobileMq.matches) { updateRail(); return; }
          const max = grid.scrollWidth - grid.clientWidth;
          const i = max > 0 ? Math.round((grid.scrollLeft / max) * (cards.length - 1)) : 0;
          slider.querySelectorAll('.drv-lres__seg').forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        }, { passive: true });
      } else {
        grid.addEventListener('scroll', updateRail, { passive: true });
      }
    });

    window.addEventListener('resize', updateRail);
    updateRail();
  });
})();
